import React, { useState } from 'react';
import { func, bool } from 'prop-types';
import IconSearch from '../../shared/icons/IconSearch';
import IconClose from '../../shared/icons/IconClose';

const AccountsSearchForm = ({ onChange, disabled = false }) => {
  const [value, setValue] = useState('');
  const [focus, setFocus] = useState(false);

  const _handleOnChange = searchValue => {
    onChange(searchValue.trim());
  };

  const onInputChange = searchValue => {
    _handleOnChange(searchValue);
    setValue(searchValue);
  };

  return (
    <div
      className={`de--search--input--root ${
        disabled ? 'de--search--input--root--disabled' : ' '
      }
      ${focus ? 'de--search--input--root--active' : ''}`}
    >
      {!value && (
        <label htmlFor="accountsSearch" className="de--search--input--icon">
          <IconSearch />
        </label>
      )}
      <div className="de--search--input">
        <input
          id="accountsSearch"
          name="accountsSearch"
          type="text"
          placeholder="Search accounts"
          className="de--search--input--field"
          value={value}
          onChange={e => onInputChange(e.target.value)}
          disabled={disabled}
          autoComplete="off"
          onFocus={() => setFocus(true)}
          onBlur={() => setFocus(false)}
        />
      </div>
      {value && (
        <div className="de--search--input--icon">
          <button
            type="button"
            onClick={() => onInputChange('')}
            title="clear search"
            className="de--search--input--icon-btn"
          >
            <IconClose />
          </button>
        </div>
      )}
    </div>
  );
};

AccountsSearchForm.propTypes = {
  onChange: func.isRequired,
  disabled: bool,
};

export default AccountsSearchForm;
